import Color from 'color';
export const convertToRgba = (color) => color ? Color(color).rgb().string() : null;
//# sourceMappingURL=convertToRgba.js.map